var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 5220.8 2271.5",
    style: {
      enableBackground: "new 0 0 5220.8 2271.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EBF3FA;}\n\t.st1{fill:#F8FBFF;}\n\t.st2{fill:#C4D9ED;}\n\t.st3{fill:#D5E7F7;}\n\t.st4{fill:#DCEAF9;}\n\t.st5{opacity:0.8;}\n\t.st6{fill:#ADC9E0;}\n\t.st7{fill:#A8D29F;}\n\t.st8{fill:#9C5F33;}\n\t.st9{fill:#E58638;}\n\t.st10{fill:#233862;}\n\t.st11{fill:#2B478B;}\n\t.st12{fill:#AB7041;}\n\t.st13{fill:#EE9849;}\n\t.st14{fill:#19A6C5;}\n\t.st15{fill:#699FF0;}\n\t.st16{fill:#AEB4C4;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_Layer_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5040.2,2266.4l1-4.9l-4444.6,0.5c0,0-3.6-7.5-4.4-9c-0.3-0.5-0.6-1.1-1-1.8l-2-3.5c-0.2-0.5-0.5-1-0.8-1.5 c-1-1.8-2.2-3.9-3.5-6.2c-1.6-2.9-3.3-6.1-5.2-9.7l0,0c-7.2-13.5-16.8-32.2-27.6-55.5c-3.6-7.6-7.3-15.8-11.1-24.4 c-1.5-3.4-3-6.9-4.6-10.5l0,0c-1.5-3.4-3-7-4.5-10.6l-0.2-0.4c-1-2.5-2.1-5-3.1-7.5s-2.2-5.2-3.3-7.9c-5.6-13.8-11.3-28.4-17-43.8 c-0.2-0.4-0.3-0.8-0.5-1.2l0,0c-3.7-10.1-7.5-20.5-11.1-31.2c-2-5.9-4-11.9-6-18c-0.1-0.4-0.2-0.7-0.4-1.1 c-0.9-2.7-1.8-5.4-2.6-8.1c-0.7-2.3-1.5-4.6-2.2-6.9c-1.5-4.8-3-9.6-4.5-14.4c-1.9-6.2-3.8-12.6-5.6-19c-2.5-8.7-4.9-17.6-7.3-26.6 c-0.7-2.7-1.4-5.4-2.1-8.1c-2.1-8.1-4.2-16.4-6.2-24.8c-0.7-2.7-1.3-5.4-1.9-8.1c-0.4-1.7-0.8-3.3-1.2-5c-3-13.2-5.9-26.7-8.6-40.4 c-2.9-15.1-5.6-30.5-8.1-46.1c-2.2-14.5-4.2-29.1-6-44c-1.7-14.1-3.1-28.3-4.2-42.6c-2.7-33.6-4-68.2-3.5-103.4 c0.8-63.4,7.9-126.5,21.2-188.5c0.5-2.3,1-4.7,1.5-7c3.4-15.2,7.3-30.5,11.5-45.8c3.3-11.6,6.8-23.3,10.5-35 c2.8-8.4,5.6-16.9,8.7-25.4c6.9-19.2,14.5-38.3,22.9-57.5c2.3-5.3,4.7-10.6,7.2-15.9c45.8-98.8,113.2-196.6,209.3-289.1 c1.8-1.7,3.6-3.4,5.4-5.2c44.5-42.7,91.6-82.7,141-119.5l5.1-3.8c509.9-373.8,940.9-120.2,1169.6-134.2 c45-2.8,84.5-20.6,123.4-48.9c71.2-51.9,140.1-138.9,236.1-232.2c144.1-139.9,349.2-294.2,714.9-366.3 c452.4-89.2,1074-64.2,1342.9,204c162.7,162.2,196.3,413.4-14.6,782.1c-12.8,22.4-26.6,45.3-41.2,68.6 c-12.3,19.6-23.1,38.3-32.3,56.1c-23.2,44.8-36.9,84.3-42.7,119.5c-13.9,84.6,18.1,144.5,75.3,193.8c16.3,13.8,33.6,26.5,51.7,38 l3.6,2.3c66.9,42.3,151.5,78.6,235.9,121.2c46.5,23.5,93,48.9,136.4,78.3c40.3,27.3,77.9,58,110.5,93.8 c21.6,23.6,40.6,49.4,56.6,77.1c0.9,1.6,1.8,3.2,2.7,4.8c21,37.5,37,79.5,46.5,127.2c0.5,2.4,1,4.9,1.4,7.3 C5060.1,2089.6,5059.2,2170.6,5040.2,2266.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M4443,1032.4l-2541.5,432.2l-182.3-218.6l2738.5-995.6C4620.4,412.5,4654,663.7,4443,1032.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3488.3,207.9l-1324.6,437c71.2-51.9,140.1-138.8,236.1-232.2L3488.3,207.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M3447.5,353.7c-32.2,0-58.2,26.1-58.2,58.2c0,32.2,26.1,58.2,58.2,58.2s58.2-26.1,58.2-58.2l0,0 C3505.7,379.8,3479.6,353.7,3447.5,353.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2410.2,
    y: 570,
    className: "st2",
    width: 302.4,
    height: 1470.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2478.2,
    y: 570,
    className: "st3",
    width: 302.4,
    height: 1470.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2478.2,
    y: 569.6,
    className: "st2",
    width: 302.4,
    height: 85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2478.2,
    y: 753.9,
    className: "st2",
    width: 302.4,
    height: 85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2478.2,
    y: 938.2,
    className: "st2",
    width: 302.4,
    height: 85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2478.2,
    y: 1122.6,
    className: "st2",
    width: 302.4,
    height: 85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2478.2,
    y: 1306.9,
    className: "st2",
    width: 302.4,
    height: 85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2478.2,
    y: 1491.2,
    className: "st2",
    width: 302.4,
    height: 85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2478.2,
    y: 1675.5,
    className: "st2",
    width: 302.4,
    height: 85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2478.2,
    y: 1859.9,
    className: "st2",
    width: 302.4,
    height: 85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2893.7,
    y: 778.1,
    className: "st2",
    width: 302.4,
    height: 1262.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2961.6,
    y: 778.1,
    className: "st3",
    width: 302.4,
    height: 1262.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2961.7,
    y: 777.8,
    className: "st2",
    width: 302.4,
    height: 73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2961.7,
    y: 936,
    className: "st2",
    width: 302.4,
    height: 73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2961.7,
    y: 1094.2,
    className: "st2",
    width: 302.4,
    height: 73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2961.7,
    y: 1252.5,
    className: "st2",
    width: 302.4,
    height: 73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2961.7,
    y: 1410.7,
    className: "st2",
    width: 302.4,
    height: 73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2961.7,
    y: 1569,
    className: "st2",
    width: 302.4,
    height: 73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2961.7,
    y: 1727.2,
    className: "st2",
    width: 302.4,
    height: 73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2961.7,
    y: 1885.5,
    className: "st2",
    width: 302.4,
    height: 73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2246.6,
    y: 1995.6,
    className: "st4",
    width: 126.6,
    height: 184.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2285.2,1743.7v512.7H943.7l-9.1-0.1l-342.4-3.2c-0.3-0.5-0.6-1.1-1-1.8l-2-3.5c-0.2-0.5-0.5-1-0.8-1.5 c-1-1.8-2.2-3.9-3.5-6.2c-1.6-2.9-3.3-6.1-5.2-9.7l0,0c-7.2-13.5-16.8-32.2-27.6-55.5c-3.6-7.6-7.3-15.8-11.1-24.4 c-1.5-3.4-3-6.9-4.6-10.5l0,0c-1.5-3.4-3-7-4.5-10.6l-0.2-0.4c-1-2.5-2.1-5-3.1-7.5s-2.2-5.2-3.3-7.9c-5.6-13.8-11.3-28.4-17-43.8 c-0.2-0.4-0.3-0.8-0.5-1.2l0,0c-3.7-10.1-7.5-20.5-11.1-31.2c-2-5.9-4-11.9-6-18c-0.1-0.4-0.2-0.7-0.4-1.1 c-0.9-2.7-1.8-5.4-2.6-8.1c-0.7-2.3-1.5-4.6-2.2-6.9c-1.5-4.8-3-9.6-4.5-14.4c-1.9-6.2-3.8-12.6-5.6-19c-2.5-8.7-4.9-17.6-7.3-26.6 c-0.7-2.7-1.4-5.4-2.1-8.1c-2.1-8.1-4.2-16.4-6.2-24.8c-0.7-2.7-1.3-5.4-1.9-8.1c-0.4-1.7-0.8-3.3-1.2-5c-3-13.2-5.9-26.7-8.6-40.4 c-2.9-15.1-5.6-30.5-8.1-46.1c-2.2-14.5-4.2-29.1-6-44c-1.7-14.1-3.1-28.3-4.2-42.6c-2.7-33.6-4-68.2-3.5-103.4 c0.8-63.4,7.9-126.5,21.2-188.5c0.5-2.3,1-4.7,1.5-7c3.4-15.2,7.3-30.5,11.5-45.8c3.3-11.6,6.8-23.3,10.5-35 c2.8-8.4,5.6-16.9,8.7-25.4c6.9-19.2,14.5-38.3,22.9-57.5h7.1v-15.9c45.8-98.8,113.2-196.6,209.3-289.1c1.8-1.7,3.6-3.4,5.4-5.2 h5.6v196.1h173.6V827.9h191.5v207.5h43.6V787.7h191.5v464.4h242.3v270.8h90.5v68.2H1871v-117.4h119.4v-319.2h147.4v589.3H2285.2z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1138.8,
    y: 819,
    className: "st2",
    width: 191.6,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1138.8,
    y: 907.9,
    className: "st2",
    width: 191.6,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1138.8,
    y: 987.9,
    className: "st2",
    width: 191.6,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 903.7,
    y: 987.9,
    className: "st2",
    width: 191.6,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 903.7,
    y: 907.9,
    className: "st2",
    width: 191.6,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 903.7,
    y: 828.1,
    className: "st2",
    width: 191.6,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 903.6,
    y: 1065.4,
    className: "st2",
    width: 426.8,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 903.6,
    y: 1143,
    className: "st2",
    width: 426.8,
    height: 47.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1989,
    y: 1154.4,
    className: "st2",
    width: 148.7,
    height: 73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1989,
    y: 1263,
    className: "st2",
    width: 148.7,
    height: 73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1989,
    y: 1371.7,
    className: "st2",
    width: 148.7,
    height: 73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1989,
    y: 1485.5,
    className: "st2",
    width: 148.7,
    height: 73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1989,
    y: 1595.8,
    className: "st2",
    width: 148.7,
    height: 73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1989,
    y: 1706.2,
    className: "st2",
    width: 148.7,
    height: 73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1989,
    y: 1821.6,
    className: "st2",
    width: 148.7,
    height: 73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 903.6,
    y: 1218.7,
    className: "st2",
    width: 426.8,
    height: 30
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1936.2,
    y: 1154.4,
    className: "st2",
    width: 54.8,
    height: 319.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1760.7,
    y: 1473.6,
    className: "st2",
    width: 110.3,
    height: 117.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M903.7,828.1v47.3v190v47.3v34.8h-38V831.8l5.1-3.8L903.7,828.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1115.4,
    y: 787.7,
    className: "st2",
    width: 23.4,
    height: 247.5
  }), /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1500.5,
    y: 1298.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1439.8,
    y: 1298.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1380.5,
    y: 1298.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1324.2,
    y: 1298.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1266.8,
    y: 1298.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1208.8,
    y: 1298.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1148.1,
    y: 1298.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088.7,
    y: 1298.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1032.4,
    y: 1298.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 975.1,
    y: 1298.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915.3,
    y: 1298.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 854.6,
    y: 1298.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 795.2,
    y: 1298.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 738.9,
    y: 1298.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 681.6,
    y: 1298.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.6,
    y: 1298.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 562.8,
    y: 1298.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.5,
    y: 1298.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M479.7,1319v25.4H471C473.8,1336,476.7,1327.5,479.7,1319z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1500.5,
    y: 1379.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1439.8,
    y: 1379.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1380.5,
    y: 1379.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1324.2,
    y: 1379.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1266.8,
    y: 1379.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1208.8,
    y: 1379.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1148.1,
    y: 1379.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088.7,
    y: 1379.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1032.4,
    y: 1379.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 975.1,
    y: 1379.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915.3,
    y: 1379.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 854.6,
    y: 1379.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 795.2,
    y: 1379.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 738.9,
    y: 1379.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 681.6,
    y: 1379.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.6,
    y: 1379.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 562.8,
    y: 1379.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.5,
    y: 1379.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M479.7,1379.4v45.8h-30.7c3.4-15.2,7.3-30.5,11.5-45.8H479.7z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1500.5,
    y: 1458.9,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1439.8,
    y: 1458.9,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1380.5,
    y: 1458.9,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1324.2,
    y: 1458.9,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1266.8,
    y: 1458.9,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1208.8,
    y: 1458.9,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1148.1,
    y: 1458.9,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088.7,
    y: 1458.9,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1032.4,
    y: 1458.9,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 975.1,
    y: 1458.9,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915.3,
    y: 1458.9,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 854.6,
    y: 1458.9,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 795.2,
    y: 1458.9,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 738.9,
    y: 1458.9,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 681.6,
    y: 1458.9,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.6,
    y: 1458.9,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 562.8,
    y: 1458.9,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.5,
    y: 1458.9,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.2,
    y: 1458.9,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1500.5,
    y: 1543.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1439.8,
    y: 1543.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1380.5,
    y: 1543.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1324.2,
    y: 1543.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1266.8,
    y: 1543.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1208.8,
    y: 1543.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1148.1,
    y: 1543.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088.7,
    y: 1543.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1032.4,
    y: 1543.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 975.1,
    y: 1543.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915.3,
    y: 1543.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 854.6,
    y: 1543.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 795.2,
    y: 1543.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 738.9,
    y: 1543.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 681.6,
    y: 1543.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.6,
    y: 1543.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 562.8,
    y: 1543.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.5,
    y: 1543.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.2,
    y: 1543.4,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1500.5,
    y: 1624.2,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1439.8,
    y: 1624.2,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1380.5,
    y: 1624.2,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1324.2,
    y: 1624.2,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1266.8,
    y: 1624.2,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1208.8,
    y: 1624.2,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1148.1,
    y: 1624.2,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088.7,
    y: 1624.2,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1032.4,
    y: 1624.2,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 975.1,
    y: 1624.2,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915.3,
    y: 1624.2,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 854.6,
    y: 1624.2,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 795.2,
    y: 1624.2,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 738.9,
    y: 1624.2,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 681.6,
    y: 1624.2,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.6,
    y: 1624.2,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 562.8,
    y: 1624.2,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.5,
    y: 1624.2,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.2,
    y: 1624.2,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1500.5,
    y: 1703.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1439.8,
    y: 1703.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1380.5,
    y: 1703.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1324.2,
    y: 1703.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1266.8,
    y: 1703.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1208.8,
    y: 1703.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1148.1,
    y: 1703.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1088.7,
    y: 1703.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1032.4,
    y: 1703.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 975.1,
    y: 1703.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 915.3,
    y: 1703.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 854.6,
    y: 1703.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 795.2,
    y: 1703.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 738.9,
    y: 1703.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 681.6,
    y: 1703.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 623.6,
    y: 1703.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 562.8,
    y: 1703.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 503.5,
    y: 1703.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 447.2,
    y: 1703.7,
    className: "st2",
    width: 32.5,
    height: 45.8
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st2",
    points: "1007,2261.6 1760.7,2261.9 1760.7,1847.1 1008.1,1847.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1578.8,
    y: 2050.1,
    className: "st2",
    width: 752.6,
    height: 203
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M947.8,1910.4v351.2l-351.2,0.5c-0.3-0.5-5-10.1-5.5-10.8l-2-3.5c-0.2-0.5-0.5-1-0.8-1.5 c-1-1.8-2.2-3.9-3.5-6.2c-1.6-2.9-3.3-6.1-5.2-9.7l0,0c-7.2-13.5-16.8-32.2-27.6-55.5c-3.6-7.6-7.3-15.8-11.1-24.4 c-1.5-3.4-3-6.9-4.6-10.5l0,0c-1.5-3.4-3-7-4.5-10.6l-0.2-0.4c-1-2.5-2.1-5-3.1-7.5s-2.2-5.2-3.3-7.9c-5.6-13.8-11.3-28.4-17-43.8 c-0.2-0.4-0.3-0.8-0.5-1.2l0,0c-3.7-10.1-7.5-20.5-11.1-31.2c-2-5.9-4-11.9-6-18c-0.1-0.4-0.2-0.7-0.4-1.1 c-0.9-2.7-1.8-5.4-2.6-8.1c-0.7-2.3-1.5-4.6-2.2-6.9c-1.5-4.8-3-9.6-4.5-14.4c-1.9-6.2-3.8-12.6-5.6-19c-2.5-8.7-4.9-17.6-7.3-26.6 c-0.7-2.7-1.4-5.4-2.1-8.1c-2.1-8.1-4.2-16.4-6.2-24.8L947.8,1910.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1570.2,
    y: 1894.6,
    className: "st3",
    width: 140.2,
    height: 75.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1390.2,
    y: 1894.6,
    className: "st3",
    width: 140.2,
    height: 75.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1213.7,
    y: 1894.6,
    className: "st3",
    width: 140.2,
    height: 75.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.5,
    y: 1894.6,
    className: "st3",
    width: 140.2,
    height: 75.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 943.7,
    y: 1847.1,
    className: "st6",
    width: 72.2,
    height: 414.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2104.2,
    y: 1122.7,
    className: "st4",
    width: 3.9,
    height: 31.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1963.7,
    y: 1122.7,
    className: "st4",
    width: 3.9,
    height: 31.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M433.9,1766.7c1.8,14.9,3.8,29.6,6,44c2.4,15.7,5.1,31,8.1,46.1c2.7,13.7,5.5,27.2,8.6,40.4 c0.4,1.7,0.8,3.3,1.2,5c0.6,2.7,1.3,5.4,1.9,8.1c2,8.4,4.1,16.6,6.2,24.8c0.7,2.7,1.4,5.4,2.1,8.1c2.4,9,4.8,17.9,7.3,26.6 c1.9,6.4,3.7,12.8,5.6,19c1.5,4.9,3,9.7,4.5,14.4c0.7,2.3,1.5,4.6,2.2,6.9c0.9,2.7,1.8,5.4,2.6,8.1c0.1,0.4,0.2,0.8,0.4,1.1 c2,6.1,4,12.1,6,18c3.7,10.7,7.4,21.1,11.1,31.2l0,0c0.1,0.4,0.3,0.8,0.5,1.2c5.7,15.4,11.4,30,17,43.8c1.1,2.7,2.2,5.3,3.3,7.9 s2.1,5.1,3.1,7.5l0.2,0.4v-362.8L433.9,1766.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M531.9,1902.3v227.2l-0.2-0.4c-1-2.5-2.1-5-3.1-7.5s-2.2-5.2-3.3-7.9c-5.6-13.8-11.3-28.4-17-43.8 c-0.2-0.4-0.3-0.8-0.5-1.2l0,0c-3.7-10.1-7.5-20.5-11.1-31.2c-2-5.9-4-11.9-6-18c-0.1-0.4-0.2-0.7-0.4-1.1 c-0.9-2.7-1.8-5.4-2.6-8.1c-0.7-2.3-1.5-4.6-2.2-6.9c-1.5-4.8-3-9.6-4.5-14.4c-1.9-6.2-3.8-12.6-5.6-19c-2.5-8.7-4.9-17.6-7.3-26.6 c-0.7-2.7-1.4-5.4-2.1-8.1c-2.1-8.1-4.2-16.4-6.2-24.8c-0.7-2.7-1.3-5.4-1.9-8.1L531.9,1902.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M531.9,1856.9v113h-56.5c-2.5-8.7-4.9-17.6-7.3-26.6c-0.7-2.7-1.4-5.4-2.1-8.1c-2.1-8.1-4.2-16.4-6.2-24.8 c-0.7-2.7-1.3-5.4-1.9-8.1c-0.4-1.7-0.8-3.3-1.2-5c-3-13.2-5.9-26.7-8.6-40.4L531.9,1856.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M496.7,2003.3v34.1c-2-5.9-4-11.9-6-18c-0.1-0.4-0.2-0.7-0.4-1.1c-0.9-2.7-1.8-5.4-2.6-8.1 c-0.7-2.3-1.5-4.6-2.2-6.9L496.7,2003.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 470.1,
    y: 1888.6,
    className: "st6",
    width: 22.3,
    height: 38.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2188.9,
    y: 1902.3,
    className: "st3",
    width: 516.7,
    height: 347.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2188.9,
    y: 1856.9,
    className: "st2",
    width: 516.7,
    height: 112.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2643.9,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2594.2,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2545.7,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2499.7,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2452.8,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2405.4,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2355.8,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2307.3,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2261.3,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2214.4,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2643.9,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2594.2,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2545.7,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2499.7,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2452.8,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2405.4,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2355.8,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2307.3,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2261.3,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2214.4,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2643.9,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2594.2,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2545.7,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2499.7,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2452.8,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2405.4,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2355.8,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2307.3,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2261.3,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2214.4,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2643.9,
    y: 1888.6,
    className: "st6",
    width: 22.3,
    height: 38.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2422.5,
    y: 1888.6,
    className: "st6",
    width: 22.3,
    height: 38.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2246.4,
    y: 1888.6,
    className: "st6",
    width: 22.3,
    height: 38.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2738.1,
    y: 1902.3,
    className: "st3",
    width: 516.7,
    height: 347.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2738.1,
    y: 1856.9,
    className: "st2",
    width: 516.7,
    height: 112.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3193,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3143.4,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3094.9,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3048.9,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3002,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2954.6,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2905,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2856.5,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2810.5,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2763.6,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3193,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3143.4,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3094.9,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3048.9,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3002,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2954.6,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2905,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2856.5,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2810.5,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2763.6,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3193,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3143.4,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3094.9,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3048.9,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3002,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2954.6,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2905,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2856.5,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2810.5,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2763.6,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3193,
    y: 1888.6,
    className: "st6",
    width: 22.3,
    height: 38.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2971.6,
    y: 1888.6,
    className: "st6",
    width: 22.3,
    height: 38.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2795.5,
    y: 1888.6,
    className: "st6",
    width: 22.3,
    height: 38.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3288.4,
    y: 1902.3,
    className: "st3",
    width: 516.7,
    height: 359.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3288.4,
    y: 1856.9,
    className: "st2",
    width: 516.7,
    height: 112.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3743.4,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3693.8,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3645.3,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3599.3,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3552.4,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3505,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3455.4,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3406.9,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3360.9,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3314,
    y: 2003.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3743.4,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3693.8,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3645.3,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3599.3,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3552.4,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3505,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3455.4,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3406.9,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3360.9,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3314,
    y: 2069.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3743.4,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3693.8,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3645.3,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3599.3,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3552.4,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3505,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3455.4,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3406.9,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3360.9,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3314,
    y: 2134.3,
    className: "st2",
    width: 26.5,
    height: 37.4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3743.4,
    y: 1888.6,
    className: "st6",
    width: 22.3,
    height: 38.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3522.1,
    y: 1888.6,
    className: "st6",
    width: 22.3,
    height: 38.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3345.9,
    y: 1888.6,
    className: "st6",
    width: 22.3,
    height: 38.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M4948.2,2260.6h-277.9c-14.9-12.6,10.3-41.3,36.6-43.2c11.4-0.9,25.9,1.5,42.4,5 c3.8-50.8,25.6-279.1,108-269.9c92.5,10.3,0,100.6-26.2,154c-19.4,39.6-39.8,96.4-49.2,123.1c7.5,1.6,15.3,3.2,23.2,4.7 c12.3-37.7,57.9-164.3,115.9-157c68.1,8.6,40.8,59.4-7.5,89.6c-35.4,22.2-78.9,53.7-99.6,68.9c17.5,2.9,35.8,4.8,54.3,4.4 C4915.9,2239,4939.1,2253,4948.2,2260.6z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "man"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M3697,740.1c0,0-8.9-42.9-31.3-52.7S3630,638.3,3621,649s2.7,82.2,19.6,91.1s25,18.2,25,18.2L3697,740.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M4080.3,569.5c0,0-142.4,248.3-194,294L3697,722.3c0,0-27.5,8.4-39.5,36c0,0,115,234.3,228.2,244.2 s272.1-280.8,272.1-280.8L4080.3,569.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M4520.9,2105.7c0,0,32.9,30.5,26.5,52.2s-36.1,36.1-40.1,62.6s-20.1,40.9-34.5,40.9h-68.9 c0,0-10.6-18.6,15-24.3s35.4-36.7,33.8-65.6s2.4-67.4,2.4-67.4l54.6-12.9L4520.9,2105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M4110.7,2260.4c-1.6,0.6-3.2,1.1-4.9,1.3h-181.7c1.4-6.3,7-19.4,29.2-23c28.8-4.7,78.6-21.4,89.8-58.2 c0.4-1.2,0.7-2.4,1-3.6c8.8-39.3,73,12,73,12s0.2,1.6,0.5,4.2C4119,2207.6,4122.9,2254.2,4110.7,2260.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M3961,1208.3c0,0,9.8,121.7,21.2,268c15.6,198.7,34.3,442.8,36.2,489c3.2,80.3,16.1,208.7,16.1,208.7 s30.5,30.5,91.5,17.7c0,0,54.4-183.3,69.9-377.3c0.2-3.2,0.5-6.4,0.7-9.6c14.5-197.5,36.9-613.3,36.9-613.3L3961,1208.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M3961,1208.3c0,0,9.8,121.7,21.2,268l213.7,338.1c0.2-3.2,0.5-6.4,0.7-9.6c14.5-197.5,36.9-613.3,36.9-613.3 L3961,1208.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M4005.5,1222.7c0,0,175.8,440.7,291.4,647.8s151.7,264.9,151.7,264.9s66.2-26.5,72.2-44.6 c0,0-44.2-399.8-121.6-497.3c-43.7-55.1-95.1-220.4-97.5-278.2s-15.6-172.2-15.6-172.2L4005.5,1222.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M4095.7,542.5c-7.8-46.2-8-73.5-8-73.5l89.2-71.9c-3.3,98.8,60,146.4,60,146.4s-118.9,58.5-187.6,36.8 C4049.3,580.3,4066.2,558.7,4095.7,542.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M4066.6,467.3c0,0,113.5,18.9,124.1-52s32.5-116.1-39.5-131.2s-90.2,9.9-99.5,32.7 S4037.4,460.6,4066.6,467.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M3953.4,1218.4c2,1.8,4.6,2.7,7.2,2.8c25.8-0.3,101,14,164.7,7.4c53.7-5.2,101.2-21,152.2-43.9 c6.8-3,22.4-11.4,22-18.9c-0.2-8.3-1-20.3-2.1-35.5c-3.6-52.6-9.9-143.2-3.8-247.7c1.1-19.4,1.7-38.7,1.8-57.7 c0.5-141.6-27.5-266.1-84-308.3c-4.8-3.5-34.4,11-61.6,24.4c-25.1,12.4-50.2,13.8-74,9l-23.7,21c-28.9,26.8-60.5,63.3-74.3,118.7 c-11.7,47.1-18.6,132.1-22.4,220.2c-1.7,39.9-3.1,80.2-3.5,118.3v1.4c-0.3,3.8-0.3,7.9-0.3,11.7 C3950.3,1139.3,3951.7,1217,3953.4,1218.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M4297.4,1130.3c-3.6-52.6-9.9-143.2-3.8-247.7c1.1-19.4,1.7-38.7,1.8-57.7c-23.5-57-42.7-98.3-42.7-98.3 h-59.2C4193.4,726.5,4150,1023.2,4297.4,1130.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M4685.5,1394.6l-15.8-110.8c-4.8-33.1-35.4-56.1-68.6-51.4l-86.9,12.4l-3.4-23.6 c-1.5-10.9-11.7-18.5-22.6-17c0,0,0,0,0,0l-75.5,10.8c-10.9,1.6-18.5,11.7-17,22.6l3.4,23.6l-50.3,7.2c-2,0.3-4,0.7-5.9,1.1 l-27.6,3.9c-33,4.8-55.9,35.3-51.3,68.3l15.6,109.5c4.8,33,35.3,55.9,68.3,51.3l20.6-2.9c4.4,0.3,8.8,0.2,13.1-0.4l252.2-35.9 C4667.2,1458.4,4690.2,1427.8,4685.5,1394.6z M4414.7,1227.4l75.5-10.8c0.7-0.1,1.5-0.1,2.2,0c3.2,0.5,5.7,3.1,6.2,6.3l3.4,23.6 l-90.2,12.9l-3.4-23.6C4407.8,1231.7,4410.6,1228,4414.7,1227.4L4414.7,1227.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M4412.6,1148.8l11.2,19.4c0,0-22,46.7,30.2,64.1c0,0,22.5,5.7,24.4-9.9s-1.4-9.5,1.9-31.5 s-5.3-41.6-21.6-46.8l-12.8-12.3L4412.6,1148.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M4442.4,1154.1c-21.3,4.2-44.5,2.5-44.5,2.5s-63.3-195.6-71.5-213.5s-188.1-229.4-188.1-229.4l75-187.6 c0,0,194.6,325.1,214.4,370.8c32.6,75.5,44,244.7,44,244.7C4462.9,1147.6,4453,1151.9,4442.4,1154.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M4190.8,408.5c0,0-11.6-2-9.8-18s1.9-37-11.2-33.1s-13.7,14.4-19.1,8.3s-5.5-31.8-44.2-33.6 s-54.6,11.7-72.6,3.8s-19-35.2-19-35.2s5.1,9.8,12.9,12.8c0,0-30.1-41.2,4.8-69.4s70.4-9.8,90.6-8.5c44.4,2.7,73.1,5.4,87.7,34.6 S4219.3,380.4,4190.8,408.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M3689.4,702.5l-46.2-93.7c-0.9-1.8-3.1-2.6-4.9-1.7l-25.7,12.7c-1.8,0.9-2.6,3.1-1.7,4.9l46.2,93.7 c0.9,1.8,3.1,2.6,4.9,1.7l25.7-12.7C3689.5,706.5,3690.3,704.3,3689.4,702.5C3689.4,702.5,3689.4,702.5,3689.4,702.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M3665.5,715.2l-46.9-95.2c-0.7-1.4-2.4-2-3.7-1.3l-15.1,7.4c-1.4,0.7-2,2.4-1.3,3.7c0,0,0,0,0,0l46.9,95.2 c0.7,1.4,2.4,1.9,3.8,1.3l15.1-7.4C3665.6,718.3,3666.1,716.6,3665.5,715.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M3482.9,1578.7c-200.4,48.7-360.6,284.7-451.6,452.4c-11.1-11.9-21.1-25.9-30.8-41.1 c38.4-86.9,112.9-273.7,40.8-267.5c-62.8,5.4-68.7,135.3-65.8,225.6c-51-88.5-108.6-191-271.9-184.5 c-270.2,10.8-353.6,291.9-541.3,286.4s-761-77.2-873.9,211.5h1975.7c-6.5-17.7-17.8-89.2-70.6-141.1c9.7-3.3,19.7-6.6,30.1-10 c167.4-54.5,104.9-110.9,104.9-110.9c-78.5,0-150.4,35.3-207.7,76.7c-8.5-2.8-17.1-5.1-25.9-6.9c-9.9-2-19.5-5.5-28.4-10.2 c99.1-113.9,241.9-259,353.7-295.7c76.4-25.1,114.8-59.5,133-92.3C3580.1,1622.5,3536.8,1565.6,3482.9,1578.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M1164.9,557.6c-143.9,0-260.6,116.7-260.6,260.6s260.6,463.9,260.6,463.9s260.6-320,260.6-463.9 S1308.8,557.6,1164.9,557.6z M1164.9,937.3c-67.3,0-121.8-54.5-121.8-121.8s54.5-121.8,121.8-121.8c67.3,0,121.8,54.5,121.8,121.8 S1232.2,937.3,1164.9,937.3C1164.9,937.3,1164.9,937.3,1164.9,937.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M2336.4,994.3c-1.2,0-2.3-0.5-3.2-1.3c-2-1.9-2.1-4.9-0.4-7c1.6-1.8,3.2-3.7,4.8-5.5c1.7-2,4.6-2.2,6.6-0.5 c0.1,0.1,0.1,0.1,0.2,0.2c2,1.9,2.1,4.9,0.3,7l-4.7,5.4C2339.1,993.7,2337.8,994.3,2336.4,994.3z M2357.5,970.4 c-1.2,0-2.4-0.5-3.3-1.3c-1.9-1.9-2-5-0.2-7c5.5-6.1,11.1-12.3,16.7-18.2c1.8-1.9,4.7-2,6.7-0.3c0,0,0.1,0.1,0.1,0.1 c1.9,1.9,2,5,0.1,7c-5.5,5.9-11.1,12-16.6,18.1C2360.1,969.8,2358.9,970.4,2357.5,970.4L2357.5,970.4z M2391,934.3 c-1.3,0-2.5-0.5-3.4-1.4c-1.9-2-1.9-5-0.1-7c5.7-6,11.5-11.9,17.2-17.7c1.8-1.9,4.8-1.9,6.6-0.1c0.1,0.1,0.1,0.1,0.2,0.2 c1.8,2,1.8,5.1-0.1,7c-5.7,5.8-11.4,11.7-17.1,17.6C2393.5,933.8,2392.3,934.3,2391,934.3L2391,934.3z M2425.5,899.3 c-1.3,0-2.6-0.6-3.5-1.5c-1.8-2-1.7-5.1,0.2-7c5.9-5.8,11.8-11.5,17.7-17.1c1.9-1.8,4.9-1.7,6.7,0.1c0,0,0.1,0.1,0.1,0.2 c1.8,2,1.7,5.1-0.3,7c-5.9,5.6-11.8,11.3-17.6,17C2428,898.8,2426.8,899.3,2425.5,899.3L2425.5,899.3z M2461.1,865.5 c-1.4,0-2.7-0.6-3.6-1.7c-1.8-2.1-1.6-5.1,0.4-7c6-5.6,12.2-11.1,18.3-16.5c1.9-1.7,4.9-1.6,6.7,0.4c0,0,0.1,0.1,0.1,0.2 c1.7,2.1,1.5,5.2-0.5,7c-6,5.4-12.1,10.9-18.1,16.4C2463.4,865,2462.3,865.5,2461.1,865.5L2461.1,865.5z M2497.8,832.8 c-1.4,0-2.8-0.7-3.7-1.8c-1.7-2.1-1.4-5.2,0.6-7c6.2-5.3,12.6-10.7,18.8-15.9c2-1.7,5-1.4,6.6,0.6c0,0.1,0.1,0.1,0.1,0.2 c1.7,2.2,1.4,5.2-0.7,7c-6.2,5.2-12.5,10.4-18.7,15.8C2500,832.4,2498.9,832.8,2497.8,832.8z M2535.6,801.6c-1.5,0-2.9-0.7-3.8-1.9 c-1.6-2.2-1.3-5.3,0.9-7c6.4-5.1,12.9-10.2,19.4-15.1c2.1-1.6,5-1.2,6.6,0.8c0,0.1,0.1,0.1,0.1,0.2c1.6,2.2,1.2,5.3-1,7 c-6.4,4.9-12.9,10-19.2,15C2537.7,801.2,2536.6,801.6,2535.6,801.6L2535.6,801.6z M2574.4,771.8c-1.6,0-3-0.8-3.9-2.1 c-1.5-2.2-1.1-5.3,1.1-6.9c6.6-4.8,13.3-9.7,19.9-14.4c2.1-1.5,5.1-1,6.6,1.1c0,0.1,0.1,0.1,0.1,0.2c1.5,2.3,0.9,5.3-1.2,6.9 c-6.6,4.7-13.2,9.4-19.8,14.3C2576.4,771.5,2575.4,771.8,2574.4,771.8L2574.4,771.8z M2614.3,743.5c-1.6,0-3.1-0.9-4-2.2 c-1.5-2.3-0.8-5.3,1.4-6.9c6.8-4.6,13.6-9.1,20.4-13.6c2.2-1.4,5.1-0.8,6.5,1.4c0,0.1,0.1,0.1,0.1,0.2c1.4,2.3,0.8,5.4-1.5,6.8 c-6.8,4.4-13.6,8.9-20.3,13.5C2616.2,743.2,2615.3,743.5,2614.3,743.5L2614.3,743.5z M2655.3,716.9c-1.7,0-3.3-0.9-4.1-2.4 c-1.4-2.3-0.6-5.3,1.6-6.8c6.9-4.3,14-8.6,21-12.7c2.3-1.3,5.2-0.6,6.5,1.7c0,0.1,0.1,0.1,0.1,0.2c1.3,2.4,0.5,5.4-1.8,6.8 c-6.9,4.1-13.9,8.3-20.8,12.6C2657.1,716.7,2656.2,717,2655.3,716.9L2655.3,716.9z M2697.3,692.1c-1.8,0-3.4-1-4.2-2.6 c-1.3-2.4-0.4-5.4,1.9-6.7c7.1-4,14.3-8,21.5-11.8c2.3-1.2,5.2-0.3,6.4,2c0,0,0.1,0.1,0.1,0.1c1.2,2.4,0.3,5.4-2.1,6.7 c-7.1,3.8-14.2,7.7-21.3,11.7C2698.9,691.9,2698.1,692.1,2697.3,692.1L2697.3,692.1z M2740.3,669.2c-1.9,0-3.5-1.1-4.3-2.8 c-1.2-2.4-0.2-5.4,2.2-6.6c7.2-3.7,14.6-7.3,21.9-10.8c2.4-1.1,5.2-0.1,6.3,2.3c0,0.1,0,0.1,0.1,0.2c1.1,2.5,0.1,5.4-2.3,6.6 c-7.2,3.5-14.6,7.1-21.8,10.7C2741.8,669,2741,669.2,2740.3,669.2L2740.3,669.2z M2784.2,648.2c-1.9,0-3.7-1.2-4.4-3 c-1.1-2.5,0-5.4,2.5-6.5c7.4-3.3,15-6.6,22.4-9.8c2.4-1,5.2,0.1,6.2,2.6c0,0.1,0,0.1,0.1,0.2c1,2.5-0.1,5.4-2.6,6.5 c-7.4,3.1-14.8,6.4-22.2,9.7C2785.5,648,2784.9,648.2,2784.2,648.2L2784.2,648.2z M3561.4,634.8c-0.7,0-1.4-0.2-2.1-0.5 c-0.1,0-7.8-3.9-22-9.7c-2.5-1.1-3.7-3.9-2.7-6.5c0.9-2.5,3.6-3.7,6.1-2.8c0,0,0.1,0,0.1,0.1c14.6,6,22.3,9.9,22.6,10 c2.4,1.3,3.4,4.2,2.2,6.6C3565,633.7,3563.3,634.8,3561.4,634.8z M2829,629.4c-2,0-3.8-1.3-4.5-3.2c-1-2.5,0.3-5.4,2.8-6.4 c7.6-3,15.2-5.9,22.8-8.7c2.5-0.9,5.2,0.4,6.1,2.9c0,0,0,0.1,0,0.1c0.9,2.6-0.4,5.4-2.9,6.3c-7.5,2.8-15.1,5.7-22.6,8.6 C2830.1,629.2,2829.6,629.3,2829,629.4L2829,629.4z M3516.5,616.1c-0.6,0-1.1-0.1-1.6-0.3c-7.4-2.7-15-5.4-22.8-8 c-2.6-0.9-3.9-3.7-3.1-6.2c0.7-2.5,3.4-4,5.9-3.2c0,0,0.1,0,0.1,0c7.8,2.6,15.6,5.3,23.1,8.1c2.5,1,3.8,3.8,2.9,6.3 C3520.4,614.8,3518.5,616.1,3516.5,616.1L3516.5,616.1z M2874.6,612.6c-2.1,0-4-1.4-4.6-3.4c-0.8-2.6,0.5-5.4,3.1-6.3 c7.7-2.6,15.5-5.2,23.2-7.6c2.5-0.8,5.2,0.6,6,3.2c0,0,0,0.1,0,0.1c0.8,2.6-0.6,5.3-3.2,6.2c-7.6,2.4-15.4,4.9-22.9,7.5 C2875.6,612.5,2875.1,612.5,2874.6,612.6L2874.6,612.6z M3470.4,600.7c-0.5,0-0.9-0.1-1.4-0.2c-7.6-2.3-15.4-4.6-23.2-6.7 c-2.6-0.8-4.1-3.5-3.4-6.1c0.6-2.6,3.2-4.2,5.8-3.6c0,0,0.1,0,0.1,0c7.9,2.2,15.7,4.4,23.4,6.8c2.6,0.8,4,3.6,3.3,6.2 C3474.5,599.2,3472.6,600.6,3470.4,600.7L3470.4,600.7z M2920.8,598c-2.2,0-4.1-1.5-4.6-3.6c-0.7-2.6,0.8-5.3,3.3-6.1 c7.8-2.2,15.7-4.4,23.5-6.4c2.6-0.6,5.2,0.9,5.8,3.5c0,0,0,0.1,0,0.1c0.6,2.6-0.9,5.3-3.5,6c-7.8,2-15.6,4.2-23.3,6.4 C2921.7,597.9,2921.3,598,2920.8,598L2920.8,598z M3423.6,587.8c-0.4,0-0.8,0-1.1-0.1c-7.8-1.9-15.7-3.7-23.5-5.5 c-2.6-0.6-4.3-3.2-3.7-5.9c0.5-2.6,3-4.3,5.6-3.9c0,0,0.1,0,0.1,0c7.9,1.7,15.9,3.6,23.7,5.5c2.6,0.7,4.2,3.4,3.6,6 C3427.8,586.2,3425.9,587.8,3423.6,587.8z M2967.8,585.7c-2.3,0-4.2-1.6-4.7-3.9c-0.6-2.6,1-5.3,3.6-5.9c7.9-1.8,15.9-3.6,23.8-5.3 c2.6-0.5,5.1,1.2,5.6,3.8c0,0,0,0.1,0,0.1c0.5,2.6-1.1,5.2-3.8,5.9c-7.8,1.6-15.8,3.4-23.5,5.2 C2968.5,585.7,2968.1,585.7,2967.8,585.7L2967.8,585.7z M3376.3,577.5c-0.3,0-0.6,0-0.9-0.1c-7.8-1.5-15.8-2.9-23.7-4.3 c-2.7-0.5-4.4-3-4-5.7c0.4-2.6,2.8-4.5,5.4-4.1c0,0,0.1,0,0.1,0c8,1.3,16.1,2.8,24,4.3c2.6,0.6,4.3,3.1,3.8,5.8 C3380.6,575.7,3378.6,577.4,3376.3,577.5L3376.3,577.5z M3015.2,575.8c-2.4,0-4.4-1.8-4.7-4.1c-0.5-2.7,1.3-5.2,3.9-5.8 c7.9-1.5,16-2.8,24-4.1c2.6-0.4,5.1,1.5,5.5,4.1c0,0,0,0,0,0c0.4,2.7-1.3,5.2-4,5.7c-7.9,1.2-15.9,2.6-23.8,4.1 C3015.8,575.8,3015.5,575.8,3015.2,575.8z M3328.5,569.5c-0.2,0-0.4,0-0.7,0c-7.9-1.1-16-2.2-23.9-3.1c-2.7-0.4-4.6-2.8-4.2-5.5 c0.2-2.7,2.6-4.6,5.3-4.4c0,0,0,0,0.1,0c8,0.9,16.1,2,24.1,3.1c2.7,0.5,4.5,2.9,4.1,5.6C3332.9,567.7,3330.9,569.5,3328.5,569.5 L3328.5,569.5z M3063,568.3c-2.5,0-4.5-1.9-4.8-4.3c-0.4-2.7,1.5-5.2,4.2-5.5c8-1.1,16.1-2,24.1-2.9c2.7-0.3,5,1.7,5.3,4.4 c0,0,0,0,0,0.1c0.3,2.7-1.6,5.1-4.3,5.5c-7.9,0.8-16,1.8-23.9,2.9C3063.4,568.2,3063.2,568.3,3063,568.3L3063,568.3z M3280.4,563.9 h-0.4c-8-0.7-16.1-1.4-24-1.9c-2.7-0.5-4.5-3.1-4.1-5.8c0.4-2.3,2.3-4,4.7-4.1c8,0.5,16.2,1.2,24.2,1.9c2.7,0.3,4.6,2.7,4.4,5.4 C3285,561.9,3282.9,563.9,3280.4,563.9L3280.4,563.9z M3111.1,563.1c-2.8-0.2-4.8-2.6-4.6-5.4c0.2-2.3,1.9-4.2,4.2-4.5 c8.1-0.7,16.2-1.2,24.3-1.7c2.8,0.2,4.9,2.5,4.7,5.3c-0.1,2.3-1.9,4.2-4.2,4.6c-8,0.5-16.1,1-24,1.7L3111.1,563.1z M3232.1,560.7 h-0.2c-8-0.3-16.1-0.6-24.1-0.7c-2.7-0.3-4.7-2.9-4.3-5.6c0.3-2.3,2.1-4.1,4.4-4.3h0.1c8.1,0.1,16.2,0.4,24.3,0.7 c2.7,0.4,4.7,2.9,4.3,5.6C3236.2,558.7,3234.4,560.5,3232.1,560.7L3232.1,560.7z M3159.5,560.3c-2.7-0.3-4.7-2.7-4.5-5.5 c0.2-2.3,2-4.1,4.3-4.4c8.1-0.3,16.2-0.4,24.3-0.5c2.7,0.3,4.7,2.7,4.5,5.5c-0.2,2.3-2.1,4.2-4.4,4.5c-8,0.1-16.1,0.2-24.1,0.5 L3159.5,560.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M1237.1,1273.2c-1.8,0-3.4-0.9-4.4-2.3c-1.9-2.6-1.5-6.2,1-8.2c0.3-0.3,8.2-6.7,23.2-17.7 c2.4-1.8,5.9-1.3,7.6,1.2c0.1,0.1,0.1,0.2,0.2,0.3c1.8,2.7,1.2,6.3-1.4,8.2c-14.8,10.8-22.7,17.3-22.8,17.3 C1239.6,1272.7,1238.4,1273.2,1237.1,1273.2z M1283.6,1238.9c-1.9,0-3.7-1-4.7-2.6c-1.7-2.7-1.1-6.3,1.6-8.2 c7.7-5.4,15.7-10.8,23.9-16.3c2.5-1.7,5.9-1,7.6,1.5c0.1,0.1,0.1,0.2,0.2,0.3c1.7,2.7,0.9,6.3-1.7,8.1c-8,5.4-16,10.8-23.7,16.1 C1285.8,1238.6,1284.7,1238.9,1283.6,1238.9L1283.6,1238.9z M1331.4,1207.1c-2,0-3.8-1.1-4.8-2.8c-1.6-2.8-0.8-6.3,1.9-8.1 c8-5.1,16.2-10.3,24.4-15.3c2.6-1.6,6-0.8,7.5,1.8c0.1,0.1,0.1,0.2,0.2,0.3c1.6,2.8,0.7,6.3-2,8.1c-8.1,5-16.3,10.1-24.2,15.2 C1333.5,1206.8,1332.4,1207.1,1331.4,1207.1z M1380.3,1177c-2.1,0-3.9-1.2-4.9-3c-1.5-2.8-0.6-6.3,2.1-8 c8.2-4.8,16.6-9.7,24.9-14.4c2.6-1.5,6-0.6,7.5,2.1c0,0.1,0.1,0.2,0.1,0.3c1.5,2.8,0.5,6.4-2.2,8c-8.3,4.7-16.6,9.5-24.7,14.3 C1382.2,1176.7,1381.2,1177,1380.3,1177L1380.3,1177z M1430,1148.7c-2.1,0-4.1-1.2-5-3.1c-1.5-2.9-0.4-6.4,2.4-7.9 c8.3-4.6,16.8-9.1,25.3-13.6c2.7-1.4,6-0.3,7.4,2.4c0,0.1,0.1,0.2,0.1,0.3c1.4,2.9,0.3,6.4-2.5,7.9c-8.4,4.4-16.8,8.9-25.1,13.5 C1431.8,1148.4,1430.9,1148.7,1430,1148.7z M1480.7,1122.1c-2.2,0-4.2-1.3-5.1-3.3c-1.4-2.9-0.2-6.4,2.6-7.8 c8.5-4.3,17.1-8.5,25.7-12.7c2.8-1.3,6.1-0.1,7.4,2.7c0,0.1,0.1,0.1,0.1,0.2c1.3,2.9,0.1,6.4-2.8,7.8c-8.5,4.1-17.1,8.3-25.5,12.6 C1482.4,1121.9,1481.5,1122.1,1480.7,1122.1z M1532.1,1097.3c-2.3,0-4.3-1.4-5.2-3.5c-1.3-2.9,0-6.4,2.9-7.8 c8.6-4,17.4-7.9,26.1-11.8c2.8-1.2,6.1,0.1,7.3,2.9c0,0.1,0.1,0.2,0.1,0.2c1.2,3-0.1,6.4-3,7.7c-8.6,3.8-17.4,7.7-25.9,11.7 C1533.7,1097.1,1532.9,1097.3,1532.1,1097.3z M1584.3,1074.3c-2.3,0-4.4-1.5-5.2-3.7c-1.2-3,0.2-6.3,3.1-7.6 c8.7-3.7,17.6-7.3,26.5-10.8c2.9-1.1,6.1,0.3,7.2,3.2c0,0.1,0,0.1,0.1,0.2c1.1,3-0.3,6.3-3.2,7.6c-8.8,3.5-17.6,7.1-26.3,10.8 C1585.7,1074.1,1585,1074.3,1584.3,1074.3L1584.3,1074.3z M1637.2,1053.2c-2.4,0-4.5-1.6-5.3-3.9c-1.1-3,0.4-6.3,3.4-7.5 c8.9-3.4,17.9-6.7,26.8-9.8c2.9-1,6.1,0.5,7.1,3.4c0,0.1,0,0.1,0.1,0.2c1,3-0.5,6.3-3.5,7.5c-8.9,3.2-17.8,6.4-26.6,9.8 C1638.5,1053.1,1637.9,1053.2,1637.2,1053.2L1637.2,1053.2z M1690.8,1034.1c-2.5,0-4.7-1.7-5.4-4.1c-1-3,0.6-6.3,3.6-7.4 c9-3,18.2-6,27.2-8.8c3-0.9,6.1,0.8,6.9,3.7c0,0.1,0,0.1,0.1,0.2c0.9,3.1-0.7,6.3-3.8,7.3c-8.9,2.8-18,5.7-27,8.7 C1692,1034,1691.4,1034.1,1690.8,1034.1L1690.8,1034.1z M1745.1,1017.1c-2.6,0-4.8-1.8-5.4-4.3c-0.9-3.1,0.9-6.3,3.9-7.2 c9.1-2.7,18.4-5.2,27.4-7.7c3-0.8,6,1,6.8,4c0,0.1,0,0.1,0,0.2c0.8,3.1-1,6.2-4,7.2c-9,2.4-18.2,5-27.2,7.7 C1746.1,1017,1745.6,1017.1,1745.1,1017.1L1745.1,1017.1z M1799.9,1002.3c-2.7,0-4.9-1.9-5.5-4.5c-0.8-3.1,1.1-6.2,4.2-7.1 c9.2-2.3,18.5-4.5,27.7-6.6c3-0.6,6,1.3,6.7,4.4c0,0,0,0.1,0,0.1c0.7,3.1-1.2,6.2-4.3,7c-9.1,2.1-18.4,4.2-27.5,6.5 C1800.8,1002.3,1800.4,1002.3,1799.9,1002.3L1799.9,1002.3z M2332.9,994.4c-0.4,0-0.9-0.1-1.3-0.2c-9.1-2.2-18.3-4.3-27.5-6.2 c-3.1-0.7-5.1-3.8-4.4-6.9c0.5-3.1,3.4-5.1,6.5-4.6c0,0,0.1,0,0.1,0c9.3,2,18.6,4.1,27.8,6.3c3.1,0.8,4.9,3.9,4.2,7 C2337.8,992.5,2335.6,994.4,2332.9,994.4L2332.9,994.4z M1855.3,989.9c-2.7,0-5.1-2.1-5.5-4.8c-0.6-3.1,1.3-6.2,4.4-6.9 c9.3-1.9,18.7-3.7,28-5.3c3.1-0.5,6,1.6,6.5,4.7c0,0,0,0.1,0,0.1c0.6,3.1-1.5,6.2-4.6,6.8c-9.2,1.6-18.5,3.4-27.7,5.3 C1856,989.8,1855.6,989.9,1855.3,989.9L1855.3,989.9z M2277.4,982.7c-0.3,0-0.7,0-1-0.1c-9.2-1.7-18.6-3.3-27.8-4.7 c-3.1-0.6-5.2-3.5-4.7-6.7c0.3-3.1,3.1-5.4,6.3-5c0,0,0.1,0,0.1,0c9.3,1.4,18.8,3,28.1,4.8c3.1,0.6,5.2,3.7,4.6,6.8 C2282.5,980.5,2280.2,982.6,2277.4,982.7L2277.4,982.7z M1911.1,979.9c-2.8-0.1-5.2-2.2-5.6-5c-0.5-3.1,1.6-6.1,4.7-6.7 c9.4-1.5,18.9-2.8,28.2-4.1c3.1-0.4,5.9,1.9,6.3,5c0,0,0,0.1,0,0.1c0.5,3.2-1.7,6.1-4.9,6.6c-9.2,1.2-18.6,2.6-27.9,4 C1911.6,979.9,1911.3,979.9,1911.1,979.9L1911.1,979.9z M2221.4,974c-0.2,0-0.5,0-0.7,0c-9.3-1.2-18.7-2.2-28-3.2 c-3.2-0.4-5.4-3.2-5.1-6.4c0.2-3.1,2.9-5.5,6-5.3c0,0,0.1,0,0.1,0c9.4,0.9,18.9,2,28.3,3.2c3.2,0.5,5.3,3.4,4.9,6.6 C2226.7,971.7,2224.3,973.9,2221.4,974L2221.4,974z M1967.2,972.4c-2.9-0.1-5.4-2.3-5.6-5.3c-0.4-3.2,1.9-6,5-6.4 c9.4-1,18.9-1.9,28.3-2.7c3.2-0.2,5.9,2.2,6.1,5.4c0,0,0,0,0,0c0.3,3.2-2,6-5.2,6.3c-9.3,0.8-18.7,1.7-28,2.7L1967.2,972.4z  M2165.1,968.4h-0.4c-9.3-0.7-18.8-1.2-28.1-1.6c-3.2-0.2-5.6-3-5.4-6.1c0-3.1,2.6-5.6,5.7-5.6c0,0,0.1,0,0.1,0 c9.4,0.4,19,1,28.4,1.6c3.2,0.3,5.5,3.1,5.2,6.3C2170.6,966,2168.1,968.4,2165.1,968.4L2165.1,968.4z M2023.7,967.7 c-3.3-0.1-5.8-2.9-5.7-6.1c0.1-2.9,2.4-5.4,5.3-5.6c9.4-0.6,19-1,28.4-1.3c3.2,0,5.9,2.6,5.9,5.9c0,3.1-2.4,5.7-5.5,5.9 c-9.3,0.3-18.8,0.8-28.1,1.3L2023.7,967.7z M2108.5,965.9h-0.1c-9.3-0.2-18.8-0.2-28.2-0.1l0,0c-3.2-0.2-5.7-3-5.5-6.2 c0.2-3,2.6-5.4,5.5-5.5c9.4-0.1,19,0,28.4,0.1c3.2,0.2,5.7,3,5.5,6.3C2114,963.4,2111.6,965.8,2108.5,965.9L2108.5,965.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M3627.4,718.9c0,0,32.4-41.1,15.5-64.9c-3.7-5.2-25,18.6-25,18.6S3624.2,710.8,3627.4,718.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M3.2,2261.6h5214.3c1.8,0,3.2,1.4,3.2,3.2v3.5c0,1.8-1.4,3.2-3.2,3.2H3.2c-1.8,0-3.2-1.4-3.2-3.2v-3.5 C0,2263,1.4,2261.6,3.2,2261.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactImg);
export default __webpack_public_path__ + "static/media/contact-img.d2cb690edb5a968a986569deccc07f47.svg";
export { ForwardRef as ReactComponent };